module.exports = __webpack_public_path__ + "img/GSC-logo.af7a7f0e.png";